<template>
     <div :class="isPublicRoute() == true ? 'adjustment contacts':'contacts'">
       <div class="contact-details">
        <div class="heading">Email Us</div>
        <p>For enquires and customer support service, please write to us using the following:</p>
        <div class="contact-items">
            <div class="contact-item">
                <div class="contact-text">info@vocation.mw</div>            
                <div class="contact-text">support@vocation.mw</div>            
            </div>
            <!-- <div class="contact-item">
                  <PhoneIcon class="contact-icon"/><div class="contact-text">{{ phone }}</div>
            </div> -->
        </div>
      
       </div>
       <div class="branding">
        <div class="heading">Social Media</div>
         <div class="icon-items">
            <a title="Facebook Page" href="https://web.facebook.com/profile.php?id=61594137043386" target="blank" class="icon-item">
                <FacebookIcon class="contact-icon"/>           
            </a>   
            <a title="LinkedIn Page" href="https://www.linkedin.com/company/vocation-software-ltd" target="blank" class="icon-item">
                <LinkedInIcon class="contact-icon"/>            
            </a>
              <a title="X Page" href="https://x.com/vocationmw" target="blank" class="icon-item">
                <XIcon class="contact-icon x-icon"/>            
            </a>     
        </div>
       </div>
    </div>
</template>
<script>
 import PageHeader from '@/components/Utility/PageHeader.vue';
  import NavLogo from '@/components/IconComponents/NavLogo.vue';
  import MailIcon from '@/components/IconComponents/MailIcon.vue';
  import PhoneIcon from '@/components/IconComponents/PhoneIcon.vue';
  import LogoIcon from './IconComponents/LogoIcon.vue';
  import FacebookIcon from './IconComponents/FacebookIcon.vue';
  import LinkedInIcon from './IconComponents/LinkedInIcon.vue';
  import XIcon from './IconComponents/XIcon.vue';
  export default{
    components:{
      PageHeader,
       NavLogo,
       PhoneIcon,
       MailIcon,
       LogoIcon,
       FacebookIcon,
       LinkedInIcon,
       XIcon
    },
    data(){
        return{
            email: process.env.VUE_APP_CONTACT_EMAIL,
            phone: process.env.VUE_APP_CONTACT_PHONE,
        }
    },
     mounted(){
       window.scrollTo({top: 0,behavior: 'smooth'});
    },
     methods:{
        isPublicRoute(){
            return this.$route.name == 'contact-us' ? true : false
        }
    }
}
</script>
<style scoped>
      .heading, p, li, .contact-text{
        font-family: var(--body-font);
    }
    p, .contact-text{
        color: white;
    }

  .heading{
        /* margin-top:-1rem; */
        color:white;
        margin-bottom:1.2rem;
        font-size:1.3rem;
        font-family:var(--job-title-font);
         
    }

    

    .adjustment{
        /* margin-top: 2.6rem!important; */
   }

   .contacts{
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap:2rem;
    /* border:1px solid black;   */
     margin-bottom:1.4rem;
     margin-top:2rem;
     padding:1rem;
     background: url('../assets/images/vocation-icon-white.svg') no-repeat 20% -2% / 25rem, var(--gradient2);
   }

   .contact-items{
    margin-bottom: 1rem;
   }

   .contact-item{
 
   }

   .contact-item:first-child{
    margin-bottom: 0.7rem;
   }

    .theme-card{
    border-radius:16px!important;
    padding:2rem;
    min-height: 25rem;
    /* background: url('../assets/images/blurs.png') fixed no-repeat center/90%, var(--intro-background); */
   }

   .contact-details{
    grid-column: 1/2;
   }

   .branding{
    /* display: grid; */
    justify-self: center;
    grid-column:2/3;
    /* align-self: center; */
    
   }

   .contact-icon{
    color:white;
    height: 1.5rem;
   }

   .x-icon{
    height: 1.9rem;
    transform: translateY(-2.7px);
   }

   .logo{
    margin-top:1rem;
    height:9rem;
    width: 22rem;
    
   }

   .icon-items{
    display:flex;
  
    column-gap:1rem;
   }

   
    @media(max-width: 768px){
        .heading{
          margin-top:0rem;
            font-size:1.2rem;
             margin-bottom:0.2rem;
             line-height:2rem;
        }

        .policy-heading{
          font-size:1rem;
        }

        p, .contact-text{
          font-size:0.9rem;
        }

        .contact-icon{
        margin-top:0.2rem;
        height: 2rem;
    }

   

   .x-icon{
    height: 2.5rem;
    transform: translateY(-3px);
   }

  

         .contacts{
            margin-top:1rem;
            display:flex;
            flex-direction: column;
            /* column-gap:2rem; */
            background: url('../assets/images/vocation-icon-white.svg') no-repeat 22% -2% / 27rem, var(--gradient2);
           
        }

          .contact-item{
 
            align-items: flex-start;
        
        }

         .icon-items{
            column-gap:0.5rem;
            margin-top: 1rem;
        }

        .icon-item{
            /* margin-right: -4rem; */
        }

        


    

    }
</style>